import { render, staticRenderFns } from "./ReceiptView.vue?vue&type=template&id=057c07b7&scoped=true"
import script from "./ReceiptView.vue?vue&type=script&lang=js"
export * from "./ReceiptView.vue?vue&type=script&lang=js"
import style0 from "./ReceiptView.vue?vue&type=style&index=0&id=057c07b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057c07b7",
  null
  
)

export default component.exports